<template>
  <v-container class="pa-0">
    <v-row class="ma-0">
      <v-col class="px-0 pr-5 py-0" cols="12" sm="6" md="4">
        <legend>Prestador</legend>
        <v-select
          v-model="formData.prestador_id"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          label="Todos"
          :items="prestadoresFilter"
          item-value="id"
          item-text="prest_nome"
          outlined
          @change="updateOperadoras(formData.prestador_id)"
        ></v-select>
      </v-col>
      <v-col class="px-0 pr-5 py-0" cols="12" sm="6" md="4">
        <legend>Operadoras</legend>
        <v-select
          v-model="formData.operadora"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          :items="operadorasFilter"
          item-value="id"
          item-text="oper_nome"
          outlined
        ></v-select>
      </v-col>
      <v-col class="px-0 py-5" cols="12" sm="6" md="4">
        <v-btn
          max-width="100%"
          height="30px"
          small
          color="primary"
          depressed
          class="px-3"
          @click="filter(formData)"
          >Filtrar</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        prestador_id: null,
        operadora: null
      },
      operadorasFilter:[],
      prestadoresFilter:[],
    }
  },
  watch: {
    prestadores:{
      deep: true,
      handler(val){
        this.prestadoresFilter = Array.from(val)
        if (this.prestadoresFilter.length==1) {
          this.formData.prestador_id = this.prestadoresFilter[0].id
          this.filter(this.formData, true)
        } else {
          this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
        }
      }
    },
    operadoras:{
      deep: true,
      handler(val){
        this.operadorasFilter = Array.from(val)
        this.operadorasFilter.unshift({id: null, oper_nome: "Todos"})
      }
    },
  },
  props: {
    filter: Function,
    prestadores: Array,
    operadoras: Array,
    updateOperadoras: Function
  }
};
</script>
